import { getFullWriterSplits } from '@disco/state-management/selectors/contacts'
import { getTrack } from '@disco/state-management/selectors/tracks'
import {
  getCustomFieldKeys,
  getCustomFieldsConfig,
  getUser,
} from '@disco/state-management/selectors/user'
import {
  getTrackCommentText,
  getWriterSplitText,
} from '@disco/utils/track-metadata'
import { createSelector } from 'reselect'
import type { RecipientList } from 'types/list'
import type { NativeTag, TrackId } from 'types/track'
// TODO: selector use util that can return dom specific value, unsafe for mobile app
// needs to be refactored
import { getTrackField } from 'utils/track-metadata'
export const getTrackPrivateMetadata = createSelector(
  [
    getTrack,
    getUser,
    getCustomFieldKeys,
    getCustomFieldsConfig,
    getFullWriterSplits,
  ],
  (track, user, customFields, customFieldsConfig, writerSplits) => {
    if (!track) {
      return []
    }

    const {
      attach_writers_to_metadata: attachWriters,
      write_native_tags_to_comments_metadata_enabled: writeNativeTags,
    } = user.business
    const result = []

    if (track.comments && track.comments?.length > 0) {
      result.push({
        name: 'Notes',
        value: track.comments.map(getTrackCommentText).join('\r\n'),
      })
    }

    if (!attachWriters && writerSplits.length > 0) {
      result.push({
        name: 'Writers',
        value: writerSplits.map(getWriterSplitText).join('\r\n'),
      })
    }

    if (!writeNativeTags && (track.native_tags?.length ?? 0) > 0) {
      result.push({
        name: 'Tags',
        value: track.native_tags?.map(({ name }: NativeTag) => name).join(', '),
      })
    }

    customFields.map((name: string) => {
      const value = getTrackField(track, name, customFieldsConfig)

      if (value) {
        result.push({
          name,
          value,
        })
      }
    })
    return result
  },
)
